import React, { useMemo } from "react";
import {
  TrendingUp, TrendingDown, BarChart3, LineChart, Activity,
  DollarSign, Percent, Hash, ArrowUpRight, ArrowDownRight, Target, Trophy,
} from "lucide-react";

const RAIN_ICONS = [TrendingUp, TrendingDown, BarChart3, LineChart, Activity,
  DollarSign, Percent, Hash, ArrowUpRight, ArrowDownRight, Target, Trophy];

// Shared "green rain" of financial/stat glyphs — reused from the landing hero so the
// in-app empty space carries the same Dynasty Metrics terminal aesthetic.
export default function MatrixRain({ columns = 24, style }) {
  const cols = useMemo(
    () => Array.from({ length: columns }, (_, i) => ({
      left: `${(i / columns) * 100}%`,
      dur: 13 + Math.random() * 14,
      delay: -Math.random() * 22,
      icons: Array.from({ length: 16 }, () => RAIN_ICONS[Math.floor(Math.random() * RAIN_ICONS.length)]),
    })),
    [columns]
  );
  return (
    <div className="matrix-rain" aria-hidden style={style} data-testid="matrix-rain">
      {cols.map((c, i) => (
        <div key={i} className="rain-col" style={{ left: c.left, animationDuration: `${c.dur}s`, animationDelay: `${c.delay}s` }}>
          {c.icons.map((Ic, j) => <Ic key={j} size={16} strokeWidth={1.6} />)}
        </div>
      ))}
    </div>
  );
}
